/** @jsx isolateComponent */

import { FlexLayout } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';

import { BillingIntervalOption } from './BillingIntervalOption';

type Props = {
  monthlyIntervalAmount: number;
  monthlyPlanId: string;
  onSelectPlanId: (planId: string) => void;
  selectedPlanId: string;
  yearlyIntervalAmount: number;
  yearlyPlanId: string;
};

export const BillingIntervalOptions = ({
  monthlyIntervalAmount,
  monthlyPlanId,
  onSelectPlanId,
  selectedPlanId,
  yearlyIntervalAmount,
  yearlyPlanId,
}: Props) => (
  <FlexLayout gutter="medium" justify="center">
    <BillingIntervalOption
      amount={yearlyIntervalAmount}
      interval="year"
      isSelected={selectedPlanId === yearlyPlanId}
      onSelect={() => onSelectPlanId(yearlyPlanId)}
    />

    <BillingIntervalOption
      amount={monthlyIntervalAmount}
      interval="month"
      isSelected={selectedPlanId === monthlyPlanId}
      onSelect={() => onSelectPlanId(monthlyPlanId)}
    />
  </FlexLayout>
);
